import React, { useContext, useEffect, useState } from 'react';
import { SspProviderContext } from '../../../index';
import SSPContentVO from 'sspcontentext/src/model/SSPContentVO';
import './styles.scss';
import { canvasFromPDF } from './canvasFromPDF';
import i18next from 'i18next';
import BackToSetup from '../BackToSetup';
import Loading from '../Loading';
import { getSetup } from '../../Functions/getSetup';
import fetchMultiLangLabel from '../../Functions/fetchMultiLangLabel';

var checkSWTimer: number | undefined;

export default function Label(props: {
	brand: string;
	apk: boolean;
	blackout: boolean;
}) {
	const setup = getSetup();

	const orientation = localStorage.getItem('orientation') || 'left';
	const store = useContext(SspProviderContext);
	const contentModel = store.state.content
		? store.state.content.asModel
		: new SSPContentVO('').asModel;

	const [asset, setAsset] = useState<string>('');
	const [type, setType] = useState<string>('');
	const deviceType = new URLSearchParams(window.location.search).get(
		'device-type'
	) || localStorage.getItem('hardware');
	const deliveryUrl =
		localStorage.getItem('use_qs') === 'true'
			? setup.market.qsUrl
			: setup.market.urls.delivery;
	const [multiLangLabelUrl, setMultiLangLabelUrl] = useState(
		`${deliveryUrl}/module/delivery/bpca/api/v2/assets/${asset}`
	);

	const [swReady, setSWReady] = useState<boolean>(false);
	const showSecondScreen =
		localStorage.getItem('show-second-screen') === 'true';

	useEffect(() => {
		const changeLanguage = (event: StorageEvent) => {
			if (event.key === 'language' && event.newValue) {
				i18next.changeLanguage(event.newValue);
				updateMultiLangLabel();
			}
		};

		window.addEventListener('storage', changeLanguage);

		return () => {
			window.removeEventListener('storage', changeLanguage);
		};
	}, []);

	useEffect(() => {
		updateMultiLangLabel();
	});

	async function updateMultiLangLabel() {
		const MultiLangLabelHash = await fetchMultiLangLabel(
			contentModel.target.second_display[i18next.language]
		);
		console.log('multi langf label hash:', MultiLangLabelHash);
		if (MultiLangLabelHash?.hash) {
			localStorage.setItem('label-hash', MultiLangLabelHash?.hash);
			localStorage.setItem('label-type', MultiLangLabelHash?.fileType);
		}
		if (!MultiLangLabelHash) {
			console.error('Failed to fetch label hash.');
			return;
		}
		setAsset(MultiLangLabelHash.hash ?? localStorage.getItem('label-hash'));
		setType(
			MultiLangLabelHash.fileType ?? localStorage.getItem('label-type')
		);

		const newUrl = multiLangLabelUrl.replace(
			/\/[^/]*$/,
			`/${MultiLangLabelHash.hash}`
		);
		setMultiLangLabelUrl(newUrl);
		localStorage.setItem('label-url', newUrl);
	}

	useEffect(() => {
		if (
			type === 'pdf' &&
			(multiLangLabelUrl || localStorage.getItem('label-url'))
		) {
			canvasFromPDF(
				multiLangLabelUrl ?? localStorage.getItem('label-url')
			);
		}
	}, [asset]);

	// repeatedly check if sw is registered
	function checkSW() {
		if (navigator.serviceWorker.controller) {
			setSWReady(true);
		} else {
			if (checkSWTimer) window.clearTimeout(checkSWTimer);
			checkSWTimer = window.setTimeout(
				() => checkSW(),
				1000 // 1s
			);
		}
	}

	if (props.blackout) return <div className='blackout' />;

	// avoid loading asset in apk second screen without a service worker to provide the authorization!
	if (
		props.apk &&
		!swReady &&
		showSecondScreen &&
		(type === 'pdf' ||
			type === 'jpg' ||
			type === 'png' ||
			type === 'svg') &&
		'serviceWorker' in navigator
	) {
		checkSW();

		return <Loading text={i18next.t('WaitingForPrimaryScreen')} />;
	}

	if (
		(type === 'jpg' || type === 'png' || type === 'svg') &&
		showSecondScreen
	) {
		return (
			<div
				className={`label ${orientation} ${type} ${
					setup.market.name === 'DEU' ? deviceType : ''
				}`}
			>
				<img
					src={multiLangLabelUrl}
					// alt={asset.asModel.str('description')}
				/>
				<BackToSetup brand={props.brand} />
			</div>
		);
	}

	if (type === 'pdf' && showSecondScreen) {
		return (
			<div
				className={`label ${orientation} ${
					setup.market.name === 'DEU' ? deviceType : ''
				}`}
			>
				<div id='canvas' />
				<BackToSetup brand={props.brand} />
			</div>
		);
	}

	return (
		<div className={`label ${orientation} label-default`}>
			<div className='wrapper'>
				<svg>
					<use xlinkHref='#brand-icon' />
				</svg>
				<h1>Digital Info Display</h1>
			</div>
			<BackToSetup brand={props.brand} />
		</div>
	);
}
